<mat-drawer-container class="height-full">
    <!-- <ng-content select="[sidedrawer]"></ng-content>
    <ng-content select="tt-side-drawer:not([ttPosition='end'])"></ng-content> -->
    <mat-drawer *ngIf="!!startDrawer" #startMatDrawer [opened]="startDrawer.ttInitialState === 'open' ? true : false" [mode]="startDrawer.ttMode" [style.width]="startDrawer.ttWidth">
        <ng-container *ngTemplateOutlet="startDrawer.templateRef"> </ng-container>
    </mat-drawer>

    <mat-drawer-content>
        <ng-content></ng-content>
    </mat-drawer-content>

    <!-- <ng-content select="tt-side-drawer[ttPosition='end']"></ng-content> -->
    <!-- <ng-content select="SideDrawerComponent[ttPosition='end']'"></ng-content> -->
    <mat-drawer *ngIf="!!endDrawer" #endMatDrawer [opened]="endDrawer.ttInitialState === 'open' ? true : false" [mode]="endDrawer.ttMode" [style.width]="endDrawer.ttWidth" position="end">
        <ng-container *ngTemplateOutlet="endDrawer.templateRef"> </ng-container>
    </mat-drawer>
</mat-drawer-container>
